import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import NoAccess from '../Common/NoAccess';
import Users from './Users';
import Tasks from './Tasks';
import Locations from './Locations/Index';
import LocationEditForm from './Locations/LocationEditForm';
import History from '../Logs/History';
import Log from '../Logs/Log';
import Profile from '../Profile/Index';
import Letter from './Letter';
import Pages from './Pages/Index';
import PageEditForm from './Pages/Form';
import DiveMode from './DiveMode/Index';
import OM from './Om';

export const Configuration = () => {
    const local = useSelector((state) => state.org.remember);
    const permissions = useSelector((state) => state[local ? 'localUser' : 'user'].permissions).split(',');
    const modules = useSelector((state) => state.org.modules);

    return (
        <>
            <Routes>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('View user') >= 0} />}>
                    <Route index element={<Users />} />
                    <Route path="users" element={<Users />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Edit user') >= 0} />}>
                    <Route path="users/:userId" element={<Profile />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('View dive') >= 0} />}>
                    <Route path="users/:userId/dives" element={<History />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Edit dive') >= 0} />}>
                    <Route path="users/:userId/dives/:diveId" element={<Log />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Add dive') >= 0} />}>
                    <Route path="users/:userId/dives/add" element={<Log />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('View user') >= 0} />}>
                    <Route path="users/:userId/reciprocity" element={<Letter />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('View user') >= 0} />}>
                    <Route path="users/:userId/reciprocity/print" element={<Letter />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('View user') >= 0} />}>
                    <Route path="users/:userId/training" element={<Letter />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Tasks') >= 0} />}>
                    <Route path="tasks" element={<Tasks />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Locations') >= 0} />}>
                    <Route path="locations" element={<Locations />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Locations') >= 0} />}>
                    <Route path="locations/:id" element={<LocationEditForm />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Dive modes') >= 0 && modules.includes('Dive modes')} />}>
                    <Route path="dive-modes" element={<DiveMode />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('OM settings') >= 0 && modules.includes('OM settings')} />}>
                    <Route path="om" element={<OM />} />
                </Route>
                {modules.includes('Pages') && (
                    <>
                        <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Pages') >= 0} />}>
                            <Route path="pages" element={<Pages />} />
                        </Route>
                        <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Edit page') >= 0} />}>
                            <Route path="pages/:id" element={<PageEditForm />} />
                        </Route>
                        <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Add page') >= 0} />}>
                            <Route path="pages/add" element={<PageEditForm />} />
                        </Route>
                    </>
                )
                }
                <Route path="*" element={<div className="error-404">There's nothing here: 404!</div>} />
            </Routes>
        </>
    );
};

export default Configuration;

const ProtectedRoute = ({ isAllowed, children }) => {
    if (!isAllowed) {
      return <NoAccess />;
    } else 
      return <>
        {children ? children : <Outlet />}
      </>;
};